// https://vuex.vuejs.org/en/state.html

export default {
  errors: [],
  isOnline: true,
  user: null,
  loading: {
    route: false,
    request: false
  },
  globalBrand: null,
  brands: [],
  brandsFilters: {
    status: "",
    validated_percent__gte: null,
    validated_percent__lte: null
  },
  catalogFilters: {
    category: "",
    product_type: "",
    discontinued: "",
    validated: "",
    gender: "",
    status: "",
    launched_at: "",
    discontinued_at: "",
    brand_id: null
  },
  notifications: [
    // {
    //   color: "success",
    //   subject:
    //     'Your edit request of the product "U Black Man" has been approved',
    //   created_at: "2021-04-05 10:54",
    //   seen: false
    // },
    // {
    //   color: "success",
    //   subject:
    //     'Your edit request of the product "Noche De Rosas" has been approved',
    //   created_at: "2021-04-05 10:54",
    //   seen: false
    // },
    // {
    //   color: "success",
    //   subject: 'Your edit request of your brand "Chanel" has been approved',
    //   created_at: "2021-04-05 10:54",
    //   seen: true
    // }
  ]
}
